// components/UniversalLayout.tsx
import { Flex, Group, Image, Stack } from "@mantine/core";
import { Link } from "react-router";
import { useGetCurrentUserQuery } from "@/setup/frontend/api/apiHooks";
import { MainMetaSettings } from "@/components/MainMetaSettings";
import MainNav from "@/components/MainNav";

type UniversalLayoutProps = {
	children: React.ReactNode;
};

export function UniversalLayout({ children }: UniversalLayoutProps) {
	const currentUser = useGetCurrentUserQuery();

	const isCaregiver = currentUser.data?.isCaregiver;

	if (isCaregiver) {
		return (
			<Flex style={{ flexGrow: 1, overflow: "hidden" }} h="100%">
				{children}
			</Flex>
		);
	}

	return (
		<Flex
			direction="row"
			align="flex-start"
			justify="flex-start"
			style={{ flexGrow: 1, overflow: "hidden" }}
			gap={0}
			data-testid={isCaregiver ? "caregiver-app-layout" : "main-layout"}
		>
			<Flex
				direction="column"
				h="100%"
				style={{
					flexShrink: 0,
					overflow: "auto",
				}}
				w={isCaregiver ? 350 : 200}
				p="md"
				gap="xl"
				className="base-100"
				visibleFrom="md"
			>
				<Stack>
					<Link to="/">
						<Image src="/logo512.png" w={30} />
					</Link>
				</Stack>

				<Stack
					gap="xs"
					style={{
						flexGrow: isCaregiver ? 1 : undefined,
						flex: isCaregiver ? 1 : undefined,
						overflow: "auto",
					}}
				>
					<nav>{<MainNav />}</nav>
				</Stack>

				{<MainMetaSettings />}
			</Flex>

			<Flex style={{ flexGrow: 1, overflow: "hidden" }} h="100%">
				{children}
			</Flex>
		</Flex>
	);
}
